<template>
  <div v-if="iconSrc" class="flex-shrink-0 flex items-center justify-center">
    <div :class="sizeClass" class="text-dark flex items-center justify-center">
      <img :src="iconSrc" alt="Alert icon" :class="size === 'small' ? 'w-full h-full' : ''">
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const ICON_CONFIG = {
  'capes_logo': 'alert1.svg',
  'alert_primary': 'alert2.svg',
  'alert_secondary': 'alert3.svg',
  'forest_primary': 'alert4.svg',
  'forest_secondary': 'alert5.svg',
  'caves_primary': 'alert6.svg',
  'caves_secondary': 'alert7.svg',
  'lighthouse_primary': 'alert8.svg',
  'lighthouse_secondary': 'alert9.svg',
  'capes_raptor_primary': 'alert10.svg',
  'capes_raptor_secondary': 'alert11.svg',
  'christmas_primary': 'christmas_primary.svg',
  'christmas_alt': 'christmas_alt.svg',
}

const props = defineProps({
  item: { type: Object, required: true },
  size: { type: String, default: 'large' }
})


const shouldShowIcon = (item) => {
  return item.show_icon !== false
}

const iconSrc = computed(() => {
  if (!shouldShowIcon(props.item)) return null
  const icon = ICON_CONFIG[props.item.alert_icon] || ICON_CONFIG.capes_logo
  return `/wp-content/themes/capes/assets/icons/alert/${icon}`
})

const sizeClass = computed(() => {
  return props.size === 'small' ? 'w-[32px] h-[32px]' : 'w-[42px] h-[42px]'
})
</script>